import React from 'react'
import './proof.scss'
function LetterProof() {
  return (
    <div className="header">

      <div className="form-div disburse-form">
      data
    </div>
    </div>
  )
}

export default LetterProof
